// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// CRITICAL FIX: Enhanced environment variable handling with fallbacks
// Primary: Environment variables (for production)
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 
  'https://vkwzngpdphbbthknrrkc.supabase.co';

const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZrd3puZ3BkcGhiYnRoa25ycmtjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMyNDIwODYsImV4cCI6MjA3ODgxODA4Nn0.zC5n8k6hlRIM2X1Y_hyQLJbFJop70qIKatL41FmmNI8';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Enhanced validation with detailed logging
if (!SUPABASE_URL) {
  console.error('Supabase Configuration Error:', {
    availableEnvVars: Object.keys(import.meta.env || {}),
    envVars: import.meta.env,
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    mode: import.meta.env.MODE,
    dev: import.meta.env.DEV,
    prod: import.meta.env.PROD
  });
  throw new Error('Missing required Supabase URL. Please check environment variables.');
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  console.error('Supabase Configuration Error:', {
    availableEnvVars: Object.keys(import.meta.env || {}),
    VITE_SUPABASE_PUBLISHABLE_KEY: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
    mode: import.meta.env.MODE,
    dev: import.meta.env.DEV,
    prod: import.meta.env.PROD
  });
  throw new Error('Missing required Supabase publishable key. Please check environment variables.');
}

// Success logging for debugging
console.log('Supabase Client Initialized:', {
  url: SUPABASE_URL,
  keyLength: SUPABASE_PUBLISHABLE_KEY?.length,
  keyPrefix: SUPABASE_PUBLISHABLE_KEY?.substring(0, 20) + '...',
  mode: import.meta.env.MODE,
  envVarsLoaded: {
    VITE_SUPABASE_URL: !!import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_PUBLISHABLE_KEY: !!import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    VITE_SUPABASE_ANON_KEY: !!import.meta.env.VITE_SUPABASE_ANON_KEY
  }
});

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof localStorage !== 'undefined' ? localStorage : {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    },
    persistSession: typeof localStorage !== 'undefined',
    autoRefreshToken: true,
  }
});

// Export configuration for debugging
export const supabaseConfig = {
  url: SUPABASE_URL,
  keyPrefix: SUPABASE_PUBLISHABLE_KEY?.substring(0, 20) + '...',
  mode: import.meta.env.MODE,
  envVarsLoaded: {
    VITE_SUPABASE_URL: !!import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_PUBLISHABLE_KEY: !!import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    VITE_SUPABASE_ANON_KEY: !!import.meta.env.VITE_SUPABASE_ANON_KEY
  }
};